/**
 * @module PhoneButton
 * @description
 */
import { useState, useContext, useEffect } from "react";
import Link from "next/link";
import { trackEvent } from "@/js/helpers/tracking";
import styles from "./DynamicButton.module.css";
import { formatPhoneNumber } from "@/js/helpers/fuse";
import { FuelContext } from "@/providers/fuel-provider";
import { DEFAULT_FUSE_NUMBER } from "@/js/constants/cohesion";

/**
 * @function PhoneButton
 * @description
 */
export const PhoneButton = ({ ...props }) => {
  delete props.href; // we need to remove the href prop otherwise we could end up going to cart
  const { location, position } = props;
  const { fuseNumber } = useContext(FuelContext);
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    setPhoneNumber(formatPhoneNumber(fuseNumber || DEFAULT_FUSE_NUMBER));
  }, [fuseNumber]);

  /**
   * @function handleClick
   * @description
   */
  const handleClick = (event) => {
    const data = {
      elementType: "BUTTON",
      location,
      position,
      text: "Phone Number",
      actionOutcome: "CLICKTOCALL",
    };

    trackEvent({ action: "elementClicked", data, event });
  };

  return (
    <Link
      href={`tel:${phoneNumber}`}
      onClick={handleClick}
      data-type="phone"
      className={`btn ${styles.component__btn}`}
      {...props}
    >
      CALL <span className="icon icon-phone-outline" /> {phoneNumber}
    </Link>
  );
};

export default PhoneButton;
